module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M4 2c0-1.106-.894-2-2-2S0 .894 0 2v29a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9h26c1.106 0 2-.894 2-2V4c0-1.106-.894-2-2-2H4zm24 8h-4v4h4v4h-4v-4h-4v4h-4v-4h-4v4H8v-4H4v-4h4V6h4v4h4V6h4v4h4V6h4v4zM8 10h4v4H8v-4zm8 0h4v4h-4v-4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/flag-1.js
// module id = 1147
// module chunks = 14